import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_API_URL;

export const post_sub_category = createAsyncThunk(
  "subcategory/post_sub_category",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/subcategory/new`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("subcategory Not create");
    }
  }
);

export const subcategoryImagePost = createAsyncThunk(
  "subcategory/subcategoryImagePost",
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: { "Content-Type": "application/json" },
        maxBodyLength: Infinity,
      };
      const url = `${Baseurl}/api/v1/subcategory/uploade-images`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("image Icon Not create");
    }
  }
);

export const get_subcategory_data = createAsyncThunk(
  "subcategory/get_subcategory_data",
  async (slugurl, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/subcategory/all`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);

export const validateSlugUrl = createAsyncThunk(
  "subcategory/validateSlugUrl",
  async (slugurl, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/subcategory/verify-slugurl/${slugurl}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);

export const subcategoryUpdate = createAsyncThunk(
  "subcategory/subcategoryUpdate",
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/subcategory/update`;
      const resp = await axios.put(url, formData, config);

      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("subcategory Not create");
    }
  }
);

const initialState = {
  sub_category_all: JSON.parse(localStorage.getItem("sub_category_all"))
    ? JSON.parse(localStorage.getItem("sub_category_all")).sort((a, b) =>
        a.createdAt > b.createdAt ? 1 : -1
      )
    : [],
  sub_category_allLoading: true,
  issub_Category_allAvailable: localStorage.getItem("sub_category_all")
    ? true
    : false,
  mobileImage: "",
  desktopImage: "",
  subcategoryImageLoading: true,
};
const SubcategorySlice = createSlice({
  name: "subcategory",
  initialState,
  reducers: {
    updateImages(state, action) {
      state.mobileImage = action.payload.mobileImage;
      state.desktopImage = action.payload.desktopImage;
      state.subcategoryImageLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(post_sub_category.pending, (state) => {
        state.sub_category_allLoading = true;
      })
      .addCase(post_sub_category.fulfilled, (state, action) => {
        state.sub_category_all = [
          ...state.sub_category_all,
          action.payload.subcategory,
        ];
        state.sub_category_all = state.sub_category_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );
        localStorage.setItem(
          "sub_category_all",
          JSON.stringify(state.sub_category_all)
        );
        state.sub_category_allLoading = false;
        state.issub_Category_allAvailable = true;
      })
      .addCase(post_sub_category.rejected, (state) => {
        state.sub_category_allLoading = true;
      });

    builder
      .addCase(subcategoryImagePost.pending, (state) => {
        state.subcategoryImageLoading = false;
      })
      .addCase(subcategoryImagePost.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.mobileImage = action.payload.mobileimages;
          state.desktopImage = action.payload.desktopImages;
        }
        state.subcategoryImageLoading = true;
      })
      .addCase(subcategoryImagePost.rejected, (state) => {
        state.subcategoryImageLoading = false;
      });

    builder
      .addCase(get_subcategory_data.pending, (state) => {
        state.sub_category_allLoading = true;
      })
      .addCase(get_subcategory_data.fulfilled, (state, action) => {
        state.sub_category_all = action.payload.subcategory;
        state.sub_category_all = state.sub_category_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );
        localStorage.setItem(
          "sub_category_all",
          JSON.stringify(state.sub_category_all)
        );
        state.sub_category_allLoading = false;
        state.issub_Category_allAvailable = true;
      })
      .addCase(get_subcategory_data.rejected, (state) => {
        state.sub_category_allLoading = true;
      });

    builder
      .addCase(subcategoryUpdate.pending, (state) => {
        state.sub_category_allLoading = true;
      })
      .addCase(subcategoryUpdate.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.sub_category_all = state.sub_category_all.filter(
            (data) => data._id !== action.payload.subcategory._id
          );
          state.sub_category_all = [
            ...state.sub_category_all,
            action.payload.subcategory,
          ];
          state.sub_category_all = state.sub_category_all.sort((a, b) =>
            a.createdAt > b.createdAt ? 1 : -1
          );
          localStorage.setItem(
            "sub_category_all",
            JSON.stringify(state.sub_category_all)
          );
        }
        state.sub_category_allLoading = true;
      })
      .addCase(subcategoryUpdate.rejected, (state) => {
        state.sub_category_allLoading = true;
      });
  },
});

export const { updateImages } = SubcategorySlice.actions;
export const authActions = SubcategorySlice.actions;
export default SubcategorySlice.reducer;
